import light from '@/style/theme/light'
import dark from '@/style/theme/dark'
import gold from '@/style/theme/gold'

export default {
    'light-theme':light,
    'dark-theme':dark,
    'gold-theme':gold
}